// extracted by mini-css-extract-plugin
export default {"tooltip":"Bn-z","sharingV2":"Cn-z","sharingIconsV2":"Dn-z","links":"En-z","link":"Fn-z","facebookV2":"Gn-z","twitterV2":"Hn-z","pinterestV2":"In-z"};